import { Button, Drawer, Form, InputNumber, Select, Input, message, Typography } from "antd"
import React, { useEffect, useState } from "react"
import { doc, serverTimestamp, updateDoc } from "firebase/firestore"
import { db } from "../../../firebase/config"

const { Link } = Typography

export default function EditRoll({ rollProp, materialLoading, materialData }) {
  const [open, setOpen] = useState(false)
  const [selectedMaterial, setSelectedMaterial] = useState()
  const [form] = Form.useForm()

  useEffect(() => {
    // only when drawer opens AND your material options are ready
    if (open && !materialLoading && materialData.length) {
      form.setFieldsValue({
        remainingMeters: rollProp.remainingMeters,
        rollWidth: rollProp.rollWidth,
        comment: rollProp.comment,
        inStock: rollProp.inStock,
        selectedMaterialID: rollProp.material?.id,
        rollLocation: rollProp.rollLocation,
        ordered: rollProp.ordered,
      })
      // also prime your state so updateRoll will include the right object
      setSelectedMaterial(rollProp.material)
    }
  }, [open, materialLoading, materialData, form, rollProp])

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  //when a form finishes
  const onFinish = (values) => {
    const data = {
      //creates a data and tells the comment could also be empty
      ...values,
      comment: values.comment || "", // Set the comment field to an empty string if it's not set explicitly in the form
    }
    updateRoll(data)
  }
  //if form failed
  const onFinishFailed = (errorInfo) => {
    message.error("Failed:", errorInfo)
  }

  const handleMaterialChange = (value, object) => {
    setSelectedMaterial(object)
  }

  //updates the roll
  const updateRoll = async (data) => {
    const newData = {
      //populates the form data with the selected material from state
      ...data,
      material: selectedMaterial,
      updated: serverTimestamp(), //adds timestamps
    }

    const ref = doc(db, "rolls", rollProp.id)
    try {
      await updateDoc(ref, newData).then(() => {
        message.success(`Success! Roll has been updated!.`)
        setOpen(false)
        form.resetFields() // Reset form fields after the data is successfully added
      })
    } catch (err) {
      message.error(err.message)
    }
  }
  return (
    <>
      <Link onClick={showDrawer}>edit</Link>
      <Drawer title="Edit roll" placement="right" onClose={onClose} open={open} width={500}>
        <Form
          form={form}
          name="basic"
          onFinish={onFinish}
          layout="vertical"
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          style={{ width: "100%" }}>
          <Form.Item
            label="Material"
            name="selectedMaterialID"
            rules={[
              {
                required: true,
                message: "Please input Meters",
              },
            ]}>
            <Select
              showSearch
              placeholder="Select a material"
              optionFilterProp="children"
              loading={materialLoading}
              onChange={handleMaterialChange}
              fieldNames={{ label: "material", value: "id" }}
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={materialData && materialData}
            />
          </Form.Item>
          <Form.Item label="Roll Location" name="rollLocation">
            <Select
              placeholder="Roll Location"
              options={[
                {
                  value: 0,
                  label: "Warehouse",
                },
                {
                  value: 1,
                  label: "Arsoma",
                },
                {
                  value: 2,
                  label: "Viva",
                },
              ]}
            />
          </Form.Item>

          <Form.Item
            label="Remaining Meters"
            name="remainingMeters"
            rules={[
              {
                required: true,
                message: "Please input Meters",
              },
            ]}>
            <InputNumber
              style={{ width: "100%" }}
              placeholder="Enter the amount of meters inside Material roll"
            />
          </Form.Item>

          <Form.Item
            label="Width"
            name="rollWidth"
            rules={[
              {
                required: true,
                message: "Please input Meters",
              },
            ]}>
            <InputNumber style={{ width: "100%" }} placeholder="Enter width of the roll" />
          </Form.Item>

          <Form.Item
            label="In Stock"
            name="inStock"
            rules={[
              {
                required: true,
                message: "Please input Meters",
              },
            ]}>
            <Select
              showSearch
              placeholder="Select roll status"
              options={[
                {
                  value: true,
                  label: "In Stock",
                },
                {
                  value: false,
                  label: "Out of Stock",
                },
              ]}
            />
          </Form.Item>

          <Form.Item name="comment" label="Comment">
            <Input.TextArea name="comment" rows={2} placeholder="Roll comment" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  )
}
